import React from "react";
import { Box, Typography, Divider } from "@mui/material";

const PrivacyPage = () => (
  <Box sx={{ maxWidth: 800, mx: "auto", px: { xs: 2, md: 4 }, py: 6 }}>
    <Typography variant="h4" sx={{ fontWeight: 800, mb: 1 }}>Privacy Policy</Typography>
    <Typography variant="body2" sx={{ color: "#888", mb: 3 }}>Last updated: March 2, 2026</Typography>
    <Divider sx={{ mb: 3 }} />

    <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>1. Information We Collect</Typography>
    <Typography variant="body2" sx={{ color: "#555", lineHeight: 1.8 }}>
      We collect minimal data to operate our service: (a) <strong>Usage data</strong> — pages visited, session duration, country of origin (via Cloudflare headers), device type; (b) <strong>Search terms</strong> — anonymous search queries entered on our site, used to improve content; (c) <strong>Chat messages</strong> — messages sent via our AI chat feature are stored anonymously with a session ID; (d) <strong>Tags and reviews</strong> — user-submitted tags and reviews are stored without personal identifiers; (e) <strong>Analytics</strong> — we use Google Analytics (GA4) to measure site traffic.
    </Typography>

    <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>2. Information We Do NOT Collect</Typography>
    <Typography variant="body2" sx={{ color: "#555", lineHeight: 1.8 }}>
      We do not collect: names, email addresses, payment information, or any personally identifiable information. No account registration is required to use this site.
    </Typography>

    <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>3. Cookies</Typography>
    <Typography variant="body2" sx={{ color: "#555", lineHeight: 1.8 }}>
      We use local storage (not cookies) to store your preferences (language, quiz completion status). Google Analytics uses cookies to measure traffic. You can disable cookies in your browser settings.
    </Typography>

    <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>4. Third-Party Services</Typography>
    <Typography variant="body2" sx={{ color: "#555", lineHeight: 1.8 }}>
      Our site links to and embeds content from third-party platforms (Streamate, LiveJasmin, Cambuilder). These platforms have their own privacy policies. When you click through to a third-party site, their privacy policy applies. We also use Twinred for advertising — their privacy policy applies to ad-related tracking.
    </Typography>

    <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>5. Data Retention</Typography>
    <Typography variant="body2" sx={{ color: "#555", lineHeight: 1.8 }}>
      Anonymous usage data is retained for up to 12 months for analytics purposes. Search terms and chat messages are retained for up to 6 months for content intelligence.
    </Typography>

    <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>6. Your Rights (GDPR / CCPA)</Typography>
    <Typography variant="body2" sx={{ color: "#555", lineHeight: 1.8 }}>
      Since we collect no personally identifiable information, most data rights (access, deletion, portability) are not applicable. For any privacy concerns, contact us at: privacy@instacamgirls.com
    </Typography>

    <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>7. Changes to This Policy</Typography>
    <Typography variant="body2" sx={{ color: "#555", lineHeight: 1.8 }}>
      We may update this policy from time to time. The date at the top of this page reflects the most recent revision.
    </Typography>

    <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>8. Contact</Typography>
    <Typography variant="body2" sx={{ color: "#555", lineHeight: 1.8 }}>
      privacy@instacamgirls.com
    </Typography>
  </Box>
);

export default PrivacyPage;
